
// import React, { useState, useMemo, useEffect } from 'react';
// import { useApp } from '../../../context/AppContext';
// import { useToast } from '../../../context/ToastContext';
// import { addAuthUser, generatePassword, sendCredentialsEmail } from '../../../utils/authUtils';
// import { apiService } from '../../../services/api';
// import DataTable from '../../../components/DataTable/DataTable';
// import StatusBadge from '../../../components/StatusBadge/StatusBadge';
// import PageHeader from '../../../components/PageHeader/PageHeader';
// import Modal from '../../../components/Modal/Modal';
// import Button from '../../../components/Form/Button';
// import Input from '../../../components/Form/Input';
// import Select from '../../../components/Form/Select';
// import './Managers.css';

// const AdminManagers = () => {
//     const { pumps } = useApp(); // don't reassign this variable
//     const { showToast } = useToast();
//     const [managers, setManagers] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [selectedManager, setSelectedManager] = useState(null);
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [isCredentialsModalOpen, setIsCredentialsModalOpen] = useState(false);
//     const [generatedCredentials, setGeneratedCredentials] = useState(null);
//     const [filters, setFilters] = useState({
//         search: '',
//         status: '',
//     });

//     console.log("pumps::::::", pumps);
//     console.log("managers::::::", managers);

//     // Normalize pumps to an array safely. The AppContext might provide pumps as { data: [...] } or as [...]
//     const pumpsList = useMemo(() => {
//         if (!pumps) return [];
//         if (Array.isArray(pumps)) return pumps;
//         if (pumps.data && Array.isArray(pumps.data)) return pumps.data;
//         return [];
//     }, [pumps]);

//     const [pagination, setPagination] = useState({
//         page: 1,
//         limit: 10,
//         total: 0,
//         totalPages: 1,
//     });

//     useEffect(() => {
//         const fetchManagers = async () => {
//             try {
//                 setLoading(true);
//                 const params = { page: pagination.page, limit: pagination.limit, user_type: 'manager' };
//                 const response = await apiService.getManagers(params);
//                 // be defensive: support response.data being array or nested
//                 const mgrs = response?.data ?? [];
//                 setManagers(Array.isArray(mgrs) ? mgrs : []);
//                 setPagination(prev => ({
//                     ...prev,
//                     total: response?.total ?? prev.total,
//                     totalPages: response?.totalPages ?? prev.totalPages,
//                 }));
//             } catch (error) {
//                 console.error('Error fetching managers:', error);
//                 showToast('Failed to load managers', 'error');
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchManagers();
//     }, [showToast, pagination.page, pagination.limit]);

//     const unassignedPumps = useMemo(() => {
//         return pumpsList.filter(p => {
//             // be flexible with pump.managerId vs manager_id etc.
//             const managerId = p.managerId ?? p.manager_id ?? p.assignedManagerId ?? '';
//             return !managerId;
//         });
//     }, [pumpsList]);

//     const [formData, setFormData] = useState({
//         name: '',
//         email: '',
//         phone: '',
//         pumpId: '',
//         city: '',
//         status: 'active',
//     });

//     const filteredManagers = useMemo(() => {
//         return managers.filter(manager => {
//             if (filters.search) {
//                 const searchLower = filters.search.toLowerCase();
//                 if (!manager.name?.toLowerCase()?.includes(searchLower) &&
//                     !manager.email?.toLowerCase()?.includes(searchLower)) {
//                     return false;
//                 }
//             }
//             if (filters.status) {
//                 const status = filters.status === 'active' ? true : false;
//                 // manager might have is_active or status; handle both
//                 if (typeof manager.is_active === 'boolean') {
//                     if (manager.is_active !== status) return false;
//                 } else if (typeof manager.status === 'string') {
//                     if ((manager.status === 'active') !== status) return false;
//                 }
//             }
//             return true;
//         });
//     }, [managers, filters]);

//     const columns = [
//         {
//             key: 'name',
//             label: 'Name',
//         },
//         {
//             key: 'email',
//             label: 'Email',
//             render: (value) => value || '-',
//         },
//         {
//             key: 'phone',
//             label: 'Phone',
//         },
//         // {
//         //     key: 'user_type',
//         //     label: 'User Type',
//         // },
//         {
//             key: 'is_active',
//             label: 'Status',
//             render: (value) => <StatusBadge status={value ? 'active' : 'inactive'} type="user" />,
//         },
//         {
//             key: 'actions',
//             label: 'Actions',
//             sortable: false,
//             render: (value, row) => (
//                 <div className="table-actions">
//                     <Button
//                         size="small"
//                         variant="outline"
//                         onClick={(e) => {
//                             e.stopPropagation();
//                             handleEdit(row);
//                         }}
//                     >
//                         Edit
//                     </Button>
//                     <Button
//                         size="small"
//                         variant={row.is_active ? 'outline' : 'primary'}
//                         onClick={(e) => {
//                             e.stopPropagation();
//                             handleToggleStatus(row);
//                         }}
//                     >
//                         {row.is_active ? 'Deactivate' : 'Activate'}
//                     </Button>
//                 </div>
//             ),
//         },
//     ];

//     const handleAdd = () => {
//         setFormData({
//             name: '',
//             email: '',
//             phone: '',
//             pumpId: '',
//             city: '',
//             status: 'active',
//         });
//         setSelectedManager(null);
//         setIsModalOpen(true);
//     };

//     const handleEdit = (manager) => {
//         setFormData({
//             name: manager.name || '',
//             email: manager.email || '',
//             phone: manager.phone || '',
//             pumpId: manager.pumpId ?? manager.pump_id ?? manager.assignedPumpId ?? '',
//             city: manager.city || '',
//             // manager might expose status string or is_active boolean
//             status: manager.status ?? (manager.is_active ? 'active' : 'inactive'),
//         });
//         setSelectedManager(manager);
//         setIsModalOpen(true);
//     };

//     // Helper to call activate/deactivate endpoint
//     const activateDeactivateApi = async (userId, isActive) => {
//         const base = "http://localhost:8001/api/v1" ?? '';
//         const url = `${base}/admin/user-listing/activate-deactivate-user/${userId}`;
//         const token = localStorage.getItem('authToken');
//         const body = { is_active: isActive }; // payload shape - server may expect this
//         const res = await fetch(url, {
//             method: 'POST', // using POST for this action; change to PATCH/PUT if your API requires it
//             headers: {
//                 'Content-Type': 'application/json',
//                 ...(token ? { Authorization: `Bearer ${token}` } : {}),
//             },
//             body: JSON.stringify(body),
//         });
//         const data = await res.json().catch(() => ({}));
//         if (!res.ok) {
//             const err = new Error(data?.message || 'Failed to update status');
//             err.response = { status: res.status, data };
//             throw err;
//         }
//         return data;
//     };

//     // Helper to call update-user endpoint
//     const updateUserApi = async (userId, updateData) => {
//         const base = "http://localhost:8001/api/v1" ?? '';
//         const url = `${base}/admin/user-listing/update-user/${userId}`;
//         const token = localStorage.getItem('authToken');
//         const res = await fetch(url, {
//             method: 'PUT', // typical method for update; change if your API expects PATCH
//             headers: {
//                 'Content-Type': 'application/json',
//                 ...(token ? { Authorization: `Bearer ${token}` } : {}),
//             },
//             body: JSON.stringify(updateData),
//         });
//         const data = await res.json().catch(() => ({}));
//         if (!res.ok) {
//             const err = new Error(data?.message || 'Failed to update user');
//             err.response = { status: res.status, data };
//             throw err;
//         }
//         return data;
//     };

//     const handleToggleStatus = async (manager) => {
//         const token = localStorage.getItem('authToken');
//         if (!token) {
//             showToast('Authentication required. Please log in again.', 'error');
//             window.location.href = '/login';
//             return;
//         }

//         try {
//             const newStatus = !manager.is_active;

//             // call activate/deactivate endpoint
//             await activateDeactivateApi(manager._id, newStatus);
//             showToast(`Manager ${newStatus ? 'activated' : 'deactivated'} successfully`, 'success');

//             // Refresh the managers list
//             const params = { page: pagination.page, limit: pagination.limit };
//             const response = await apiService.getManagers(params);
//             const mgrs = response?.data ?? [];
//             setManagers(Array.isArray(mgrs) ? mgrs : []);
//         } catch (error) {
//             console.error('Error toggling manager status:', error);
//             if (error.response?.status === 401) {
//                 showToast('Session expired. Please log in again.', 'error');
//                 // Token removal and redirect handled by interceptor if present
//             } else {
//                 showToast(error.message || 'Failed to update manager status', 'error');
//             }
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const token = localStorage.getItem('authToken');
//         if (!token) {
//             showToast('Authentication required. Please log in again.', 'error');
//             window.location.href = '/login';
//             return;
//         }

//         try {
//             if (selectedManager) {
//                 // Edit existing manager
//                 const updateData = {
//                     name: formData.name,
//                     email: formData.email,
//                     phone: formData.phone,
//                     is_active: formData.status === 'active',
//                     // you can include other fields you want to update, e.g. city, pump assignment etc.
//                     // e.g. pumpId: formData.pumpId
//                 };

//                 // call update-user endpoint
//                 await updateUserApi(selectedManager._id, updateData);
//                 showToast('Manager updated successfully', 'success');
//             } else {
//                 // Add new manager
//                 const userData = {
//                     name: formData.name,
//                     email: formData.email,
//                     phone: formData.phone,
//                     password: formData.password || generatePassword(),
//                     user_type: 'manager',
//                     is_active: formData.status === 'active',
//                 };
//                 await apiService.addUser(userData);
//                 showToast('Manager added successfully', 'success');
//             }

//             // Refresh the managers list
//             const params = { page: pagination.page, limit: pagination.limit };
//             const response = await apiService.getManagers(params);
//             const mgrs = response?.data ?? [];
//             setManagers(Array.isArray(mgrs) ? mgrs : []);

//             setIsModalOpen(false);
//             setSelectedManager(null);
//         } catch (error) {
//             console.error('Error saving manager:', error);
//             if (error.response?.status === 401) {
//                 showToast('Session expired. Please log in again.', 'error');
//                 // Token removal and redirect handled by interceptor
//             } else {
//                 showToast(error.message || 'Failed to save manager', 'error');
//             }
//         }
//     };

//     return (
//         <div className="admin-managers">
//             <PageHeader
//                 title="Managers"
//                 actions={
//                     <Button variant="primary" onClick={handleAdd}>
//                         + Add Manager
//                     </Button>
//                 }
//             />

//             <div className="managers-filters">
//                 <Input
//                     label="Search by Name/Email"
//                     placeholder="Search managers..."
//                     value={filters.search}
//                     onChange={(e) => setFilters({ ...filters, search: e.target.value })}
//                 />
//                 <Select
//                     label="Filter by Status"
//                     value={filters.status}
//                     onChange={(e) => setFilters({ ...filters, status: e.target.value })}
//                     options={[
//                         { value: '', label: 'All Status' },
//                         { value: 'active', label: 'Active' },
//                         { value: 'inactive', label: 'Inactive' },
//                     ]}
//                 />
//             </div>

//             <DataTable
//                 columns={columns}
//                 data={filteredManagers}
//                 searchable={false}
//                 loading={loading}
//                 pagination={pagination}
//                 onPageChange={(page) => setPagination(prev => ({ ...prev, page }))}
//                 onLimitChange={(limit) => setPagination(prev => ({ ...prev, limit, page: 1 }))}
//             />

//             {/* Add/Edit Modal */}
//             <Modal
//                 isOpen={isModalOpen}
//                 onClose={() => {
//                     setIsModalOpen(false);
//                     setSelectedManager(null);
//                 }}
//                 title={selectedManager ? 'Edit Manager' : 'Add New Manager'}
//                 size="medium"
//             >
//                 <form onSubmit={handleSubmit} className="manager-form">
//                     <div className="form-row">
//                         <Input
//                             label="Name *"
//                             value={formData.name}
//                             onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//                             required
//                         />
//                         <Input
//                             label="Email *"
//                             type="email"
//                             value={formData.email}
//                             onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//                             required
//                             disabled={!!selectedManager}
//                         />
//                     </div>

//                     <div className="form-row">
//                         <Input
//                             label="Phone"
//                             value={formData.phone}
//                             onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
//                         />
//                         <Input
//                             label="City"
//                             value={formData.city}
//                             onChange={(e) => setFormData({ ...formData, city: e.target.value })}
//                         />
//                     </div>

//                     <Select
//                         label="Assigned Pump"
//                         value={formData.pumpId}
//                         onChange={(e) => setFormData({ ...formData, pumpId: e.target.value })}
//                         options={[
//                             { value: '', label: 'Unassigned' },
//                             // make sure pumpsList is an array; map safely and provide sensible fallbacks
//                             ...pumpsList.map((p) => ({
//                                 value: p.id ?? p._id ?? '',
//                                 label: p.pumpName ?? p.name ?? `Pump ${p.id ?? p._id ?? ''}`
//                             })),
//                         ]}
//                     />

//                     <div className="form-group">
//                         <label className="form-label">Status</label>
//                         <Select
//                             value={formData.status}
//                             onChange={(e) => setFormData({ ...formData, status: e.target.value })}
//                             options={[
//                                 { value: 'active', label: 'Active' },
//                                 { value: 'inactive', label: 'Inactive' },
//                             ]}
//                         />
//                     </div>

//                     {!selectedManager && (
//                         <div className="info-note">
//                             <p>💡 A random password will be generated and displayed after creation.</p>
//                         </div>
//                     )}

//                     <div className="modal-actions">
//                         <Button
//                             type="button"
//                             variant="outline"
//                             onClick={() => {
//                                 setIsModalOpen(false);
//                                 setSelectedManager(null);
//                             }}
//                         >
//                             Cancel
//                         </Button>
//                         <Button type="submit" variant="primary">
//                             {selectedManager ? 'Update Manager' : 'Create Manager'}
//                         </Button>
//                     </div>
//                 </form>
//             </Modal>

//             {/* Credentials Display Modal */}
//             <Modal
//                 isOpen={isCredentialsModalOpen}
//                 onClose={() => {
//                     setIsCredentialsModalOpen(false);
//                     setGeneratedCredentials(null);
//                 }}
//                 title="Manager Credentials"
//                 size="small"
//             >
//                 {generatedCredentials && (
//                     <div className="credentials-display">
//                         <p className="credentials-note">
//                             ⚠️ <strong>Save these credentials!</strong> They won't be shown again.
//                         </p>
//                         <div className="credentials-info">
//                             <div className="credential-item">
//                                 <label>Name:</label>
//                                 <span>{generatedCredentials.name}</span>
//                             </div>
//                             <div className="credential-item">
//                                 <label>Email:</label>
//                                 <span>{generatedCredentials.email}</span>
//                             </div>
//                             <div className="credential-item">
//                                 <label>Password:</label>
//                                 <div className="password-display">
//                                     <code>{generatedCredentials.password}</code>
//                                     <Button
//                                         size="small"
//                                         variant="outline"
//                                         onClick={() => {
//                                             navigator.clipboard.writeText(generatedCredentials.password);
//                                             showToast('Password copied to clipboard', 'success');
//                                         }}
//                                     >
//                                         Copy
//                                     </Button>
//                                 </div>
//                             </div>
//                         </div>
//                         <p className="credentials-instruction">
//                             The manager can now log in at the login page using these credentials.
//                         </p>
//                         <div className="modal-actions">
//                             <Button
//                                 variant="primary"
//                                 onClick={() => {
//                                     setIsCredentialsModalOpen(false);
//                                     setGeneratedCredentials(null);
//                                 }}
//                             >
//                                 Got it
//                             </Button>
//                         </div>
//                     </div>
//                 )}
//             </Modal>
//         </div>
//     );
// };

// export default AdminManagers;




import React, { useState, useMemo, useEffect } from 'react';
import { useApp } from '../../../context/AppContext';
import { useToast } from '../../../context/ToastContext';
import { addAuthUser, generatePassword, sendCredentialsEmail } from '../../../utils/authUtils';
import { API_BASE_URL, apiService } from '../../../services/api';
import DataTable from '../../../components/DataTable/DataTable';
import StatusBadge from '../../../components/StatusBadge/StatusBadge';
import PageHeader from '../../../components/PageHeader/PageHeader';
import Modal from '../../../components/Modal/Modal';
import Button from '../../../components/Form/Button';
import Input from '../../../components/Form/Input';
import Select from '../../../components/Form/Select';
import './Managers.css';

const AdminManagers = () => {
    const { pumps } = useApp(); // don't reassign this variable
    const { showToast } = useToast();
    const [managers, setManagers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedManager, setSelectedManager] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCredentialsModalOpen, setIsCredentialsModalOpen] = useState(false);
    const [generatedCredentials, setGeneratedCredentials] = useState(null);
    const [filters, setFilters] = useState({
        search: '',
        status: '',
    });

    console.log("pumps::::::", pumps);
    console.log("managers::::::", managers);

    // Normalize pumps to an array safely. The AppContext might provide pumps as { data: [...] } or as [...]
    const pumpsList = useMemo(() => {
        if (!pumps) return [];
        if (Array.isArray(pumps)) return pumps;
        if (pumps.data && Array.isArray(pumps.data)) return pumps.data;
        return [];
    }, [pumps]);

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10000,
        total: 0,
        totalPages: 1,
    });

    useEffect(() => {
        const fetchManagers = async () => {
            try {
                setLoading(true);
                const params = { page: pagination.page, limit: pagination.limit, user_type: 'manager' };
                const response = await apiService.getManagers(params);
                // be defensive: support response.data being array or nested
                const mgrs = response?.data ?? [];
                setManagers(Array.isArray(mgrs) ? mgrs : []);
                setPagination(prev => ({
                    ...prev,
                    total: response?.total ?? prev.total,
                    totalPages: response?.totalPages ?? prev.totalPages,
                }));
            } catch (error) {
                console.error('Error fetching managers:', error);
                showToast('Failed to load managers', 'error');
            } finally {
                setLoading(false);
            }
        };
        fetchManagers();
    }, [showToast, pagination.page, pagination.limit]);

    const unassignedPumps = useMemo(() => {
        return pumpsList.filter(p => {
            // be flexible with pump.managerId vs manager_id etc.
            const managerId = p.managerId ?? p.manager_id ?? p.assignedManagerId ?? '';
            return !managerId;
        });
    }, [pumpsList]);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        pumpId: '',
        city: '',
        status: 'active',
    });

    const filteredManagers = useMemo(() => {
        return managers.filter(manager => {
            if (filters.search) {
                const searchLower = filters.search.toLowerCase();
                if (!manager.name?.toLowerCase()?.includes(searchLower) &&
                    !manager.email?.toLowerCase()?.includes(searchLower)) {
                    return false;
                }
            }
            if (filters.status) {
                const status = filters.status === 'active' ? true : false;
                // manager might have is_active or status; handle both
                if (typeof manager.is_active === 'boolean') {
                    if (manager.is_active !== status) return false;
                } else if (typeof manager.status === 'string') {
                    if ((manager.status === 'active') !== status) return false;
                }
            }
            return true;
        });
    }, [managers, filters]);

    const columns = [
        {
            key: 'name',
            label: 'Name',
        },
        {
            key: 'email',
            label: 'Email',
            render: (value) => value || '-',
        },
        {
            key: 'phone',
            label: 'Phone',
        },
        // {
        //     key: 'user_type',
        //     label: 'User Type',
        // },
        {
            key: 'is_active',
            label: 'Status',
            render: (value) => <StatusBadge status={value ? 'active' : 'inactive'} type="user" />,
        },
        {
            key: 'actions',
            label: 'Actions',
            sortable: false,
            render: (value, row) => (
                <div className="table-actions">
                    <Button
                        size="small"
                        variant="outline"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleEdit(row);
                        }}
                    >
                        Edit
                    </Button>
                    <Button
                        size="small"
                        variant={row.is_active ? 'outline' : 'primary'}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleToggleStatus(row);
                        }}
                    >
                        {row.is_active ? 'Deactivate' : 'Activate'}
                    </Button>
                </div>
            ),
        },
    ];

    const handleAdd = () => {
        setFormData({
            name: '',
            email: '',
            phone: '',
            pumpId: '',
            city: '',
            status: 'active',
        });
        setSelectedManager(null);
        setIsModalOpen(true);
    };

    const handleEdit = (manager) => {
        setFormData({
            name: manager.name || '',
            email: manager.email || '',
            phone: manager.phone || '',
            pumpId: manager.pumpId ?? manager.pump_id ?? manager.assignedPumpId ?? '',
            city: manager.city || '',
            // manager might expose status string or is_active boolean
            status: manager.status ?? (manager.is_active ? 'active' : 'inactive'),
        });
        setSelectedManager(manager);
        setIsModalOpen(true);
    };

    // Helper to call activate/deactivate endpoint
    const activateDeactivateApi = async (userId, isActive) => {
        const url = `${API_BASE_URL}/admin/user-listing/activate-deactivate-user/${userId}`;
        const token = localStorage.getItem('authToken');
        const body = { is_active: isActive }; // payload shape - server may expect this
        const res = await fetch(url, {
            method: 'POST', // using POST for this action; change to PATCH/PUT if your API requires it
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(body),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
            const err = new Error(data?.message || 'Failed to update status');
            err.response = { status: res.status, data };
            throw err;
        }
        return data;
    };

    // Helper to call update-user endpoint
    const updateUserApi = async (userId, updateData) => {
       
        const url = `${API_BASE_URL}/admin/user-listing/update-user/${userId}`;
        const token = localStorage.getItem('authToken');
        const res = await fetch(url, {
            method: 'PUT', // typical method for update; change if your API expects PATCH
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(updateData),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
            const err = new Error(data?.message || 'Failed to update user');
            err.response = { status: res.status, data };
            throw err;
        }
        return data;
    };

    // Helper to call add-users endpoint
    const addUserApi = async (userPayload) => {
        
        const url = `${API_BASE_URL}/admin/user-listing/add-users`;
        const token = localStorage.getItem('authToken');
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(userPayload),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
            const err = new Error(data?.message || 'Failed to add user');
            err.response = { status: res.status, data };
            throw err;
        }
        return data;
    };

    const handleToggleStatus = async (manager) => {
        const token = localStorage.getItem('authToken');
        if (!token) {
            showToast('Authentication required. Please log in again.', 'error');
            window.location.href = '/login';
            return;
        }

        try {
            const newStatus = !manager.is_active;

            // call activate/deactivate endpoint
            await activateDeactivateApi(manager._id, newStatus);
            showToast(`Manager ${newStatus ? 'activated' : 'deactivated'} successfully`, 'success');

            // Refresh the managers list
            const params = { page: pagination.page, limit: pagination.limit };
            const response = await apiService.getManagers(params);
            const mgrs = response?.data ?? [];
            setManagers(Array.isArray(mgrs) ? mgrs : []);
        } catch (error) {
            console.error('Error toggling manager status:', error);
            if (error.response?.status === 401) {
                showToast('Session expired. Please log in again.', 'error');
                // Token removal and redirect handled by interceptor if present
            } else {
                showToast(error.message || 'Failed to update manager status', 'error');
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('authToken');
        if (!token) {
            showToast('Authentication required. Please log in again.', 'error');
            window.location.href = '/login';
            return;
        }

        try {
            if (selectedManager) {
                // Edit existing manager
                const updateData = {
                    name: formData.name,
                    email: formData.email,
                    phone: formData.phone,
                    is_active: formData.status === 'active',
                    // you can include other fields you want to update, e.g. city, pump assignment etc.
                    // e.g. pumpId: formData.pumpId
                };

                // call update-user endpoint
                await updateUserApi(selectedManager._id, updateData);
                showToast('Manager updated successfully', 'success');
            } else {
                // Add new manager using /admin/user-listing/add-users
                const password = formData.password || generatePassword();
                const userPayload = {
                    name: formData.name,
                    email: formData.email,
                    password,
                    user_type: 'manager',
                    // include phone only if provided to avoid sending empty string if not wanted
                    ...(formData.phone ? { phone: formData.phone } : {}),
                };

                const resp = await addUserApi(userPayload);

                // Show generated credentials to the admin
                setGeneratedCredentials({
                    name: formData.name,
                    email: formData.email,
                    password,
                });
                setIsCredentialsModalOpen(true);

                showToast('Manager added successfully', 'success');
            }

            // Refresh the managers list
            const params = { page: pagination.page, limit: pagination.limit, user_type: 'manager' };
            const response = await apiService.getManagers(params);
            const mgrs = response?.data ?? [];
            setManagers(Array.isArray(mgrs) ? mgrs : []);

            setIsModalOpen(false);
            setSelectedManager(null);
            // clear password field from formData if any
            setFormData((prev) => ({ ...prev, password: '' }));
        } catch (error) {
            console.error('Error saving manager:', error);
            if (error.response?.status === 401) {
                showToast('Session expired. Please log in again.', 'error');
                // Token removal and redirect handled by interceptor
            } else {
                showToast(error.message || 'Failed to save manager', 'error');
            }
        }
    };

    return (
        <div className="admin-managers">
            <PageHeader
                title="Managers"
                actions={
                    <Button variant="primary" onClick={handleAdd}>
                        + Add Manager
                    </Button>
                }
            />

            <div className="managers-filters">
                <Input
                    label="Search by Name/Email"
                    placeholder="Search managers..."
                    value={filters.search}
                    onChange={(e) => setFilters({ ...filters, search: e.target.value })}
                />
                <Select
                    label="Filter by Status"
                    value={filters.status}
                    onChange={(e) => setFilters({ ...filters, status: e.target.value })}
                    options={[
                        { value: '', label: 'All Status' },
                        { value: 'active', label: 'Active' },
                        { value: 'inactive', label: 'Inactive' },
                    ]}
                />
            </div>

            <DataTable
                columns={columns}
                data={filteredManagers}
                searchable={false}
                loading={loading}
                pagination={pagination}
                onPageChange={(page) => setPagination(prev => ({ ...prev, page }))}
                onLimitChange={(limit) => setPagination(prev => ({ ...prev, limit, page: 1 }))}
            />

            {/* Add/Edit Modal */}
            <Modal
                isOpen={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false);
                    setSelectedManager(null);
                }}
                title={selectedManager ? 'Edit Manager' : 'Add New Manager'}
                size="medium"
            >
                <form onSubmit={handleSubmit} className="manager-form">
                    <div className="form-row">
                        <Input
                            label="Name *"
                            value={formData.name}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                            required
                        />
                        <Input
                            label="Email *"
                            type="email"
                            value={formData.email}
                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                            required
                            disabled={!!selectedManager}
                        />
                    </div>

                    <div className="form-row">
                        <Input
                            label="Phone"
                            value={formData.phone}
                            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                        />
                        <Input
                            label="City"
                            value={formData.city}
                            onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                        />
                    </div>

                    <Select
                        label="Assigned Pump"
                        value={formData.pumpId}
                        onChange={(e) => setFormData({ ...formData, pumpId: e.target.value })}
                        options={[
                            { value: '', label: 'Unassigned' },
                            // make sure pumpsList is an array; map safely and provide sensible fallbacks
                            ...pumpsList.map((p) => ({
                                value: p.id ?? p._id ?? '',
                                label: p.pumpName ?? p.name ?? `Pump ${p.id ?? p._id ?? ''}`
                            })),
                        ]}
                    />

                    <div className="form-group">
                        <label className="form-label">Status</label>
                        <Select
                            value={formData.status}
                            onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                            options={[
                                { value: 'active', label: 'Active' },
                                { value: 'inactive', label: 'Inactive' },
                            ]}
                        />
                    </div>

                    {!selectedManager && (
                        <div className="info-note">
                            <p>💡 A random password will be generated and displayed after creation.</p>
                        </div>
                    )}

                    <div className="modal-actions">
                        <Button
                            type="button"
                            variant="outline"
                            onClick={() => {
                                setIsModalOpen(false);
                                setSelectedManager(null);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button type="submit" variant="primary">
                            {selectedManager ? 'Update Manager' : 'Create Manager'}
                        </Button>
                    </div>
                </form>
            </Modal>

            {/* Credentials Display Modal */}
            <Modal
                isOpen={isCredentialsModalOpen}
                onClose={() => {
                    setIsCredentialsModalOpen(false);
                    setGeneratedCredentials(null);
                }}
                title="Manager Credentials"
                size="small"
            >
                {generatedCredentials && (
                    <div className="credentials-display">
                        <p className="credentials-note">
                            ⚠️ <strong>Save these credentials!</strong> They won't be shown again.
                        </p>
                        <div className="credentials-info">
                            <div className="credential-item">
                                <label>Name:</label>
                                <span>{generatedCredentials.name}</span>
                            </div>
                            <div className="credential-item">
                                <label>Email:</label>
                                <span>{generatedCredentials.email}</span>
                            </div>
                            <div className="credential-item">
                                <label>Password:</label>
                                <div className="password-display">
                                    <code>{generatedCredentials.password}</code>
                                    <Button
                                        size="small"
                                        variant="outline"
                                        onClick={() => {
                                            navigator.clipboard.writeText(generatedCredentials.password);
                                            showToast('Password copied to clipboard', 'success');
                                        }}
                                    >
                                        Copy
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <p className="credentials-instruction">
                            The manager can now log in at the login page using these credentials.
                        </p>
                        <div className="modal-actions">
                            <Button
                                variant="primary"
                                onClick={() => {
                                    setIsCredentialsModalOpen(false);
                                    setGeneratedCredentials(null);
                                }}
                            >
                                Got it
                            </Button>
                        </div>
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default AdminManagers;

